// extracted by mini-css-extract-plugin
module.exports = {"mainArea":"main_mainArea__2g_i8","canvasContainer":"main_canvasContainer__12eZs","colorPickerContainer":"main_colorPickerContainer__3-Xf1"};